<template>
  <div class="dialogs">
    <template v-for="item in dialogs">
      <component :is="item.tempModule" :key="item.name" @onClose="onClose" class="dialog"></component>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
export default {
  name: 'dialogs',
  data() {
    return {
      dialogs: [],
      type: {}
    }
  },
  props: {
    dialog: {
      type: [Object],
      default() {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters('Authentication', ['UserInfo'])
  },
  mounted() {
    this.type = {
      code: this.UserInfo.user && `${this.UserInfo.user.name}${this.UserInfo.user.jobNumber}`,
      width: 140,
      height: 80,
      fontSize: '14',
      fontFamily: '',
      paddingLeft: 30,
      paddingRight: 30,
      paddingTop: 30,
      paddingBottom: 30
    }
  },
  watch: {
    dialog(next) {
      this.loadDialog(
        {
          name: next.name,
          module: next.module,
          data: JSON.parse(JSON.stringify(next.data)),
          methods: next.methods
        },
        tempModule => {
          this.dialogs.push({ name: next.name, tempModule })
          this.$nextTick(() => {
            let doc = document.querySelectorAll('.el-dialog__wrapper')
            doc = doc?.[doc?.length - 1]?.querySelector?.('.el-dialog')
            if (doc) {
              doc.style.marginTop = `15vh` // background-image:url(${this.watermark});
            }
          })
        }
      )
    }
  },
  methods: {
    onPicture(val) {
      this.watermark = val
    },
    onClose() {
      const length = this.dialogs.length - 1
      this.dialogs.splice(length, 1)
    },
    loadDialog(data, fn) {
      // eslint-disable-next-line no-useless-escape
      let name = data.name.replace(/\-/g, '/')
      import(/* webpackExclude: /\.md$/ */ '../pages/' + data.module + '/container/' + name + '')
        .then(module => {
          name = name.replace(/\//g, '-')
          module.name = name
          // 加载弹出框模块
          // 注入method 方法,注入初始化数据
          let tempModule = Vue.extend(module.default)
          tempModule = tempModule.extend({
            data: function() {
              return data.data
            },
            methods: data.methods
          })
          // Vue.component(name, tempModule)
          fn(tempModule)
        })
        .catch(err => {
          console.log(err)
          console.log('Chunk loading failed', name)
        })
    }
  }
}
</script>
<style lang="stylus">
.dialog {
}
</style>
